import { atom } from 'jotai';

export const sendCJToCMSPayloadAtom = atom<
  | {
      date: Date;
    }
  | undefined
>(undefined);
